import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import AftersalesCard from "../../cards/AftersalesCard/AftersalesCard";
import aftersalesData from "../../../data/aftersalesData";
import aftersalesBg from "../../../assets/images/aftersalesBanner.png";
import { useTranslation } from "react-i18next";
import "./AftersalesSupportSection.css";

export default function AftersalesSupportSection() {
  const { t } = useTranslation();

  return (
    <section
      className="aftersales-section section-spacing"
      style={{
        backgroundImage: `linear-gradient(120deg, rgba(60, 42, 152,0.78)), url(${aftersalesBg})`,
      }}
    >
      <Container fluid="lg">
        <Row className="align-items-center">
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <div className="aftersales-section__content">
              <SectionTitle
                className="text-white mb-3"
                subtitle={t("common.aftersales.sectionSubtitle")}
                title={t("common.aftersales.sectionTitle")}
                align="left"
              />

              <p className="aftersales-section__text">
                {t("common.aftersales.sectionText")}
              </p>

              <p className="aftersales-section__quote">
                {t("common.aftersales.sectionQuote")}
              </p>
            </div>
          </Col>

          <Col xs={12} lg={6}>
            <div className="aftersales-section__cards">
              {aftersalesData.map((item) => (
                <AftersalesCard
                  key={item.id}
                  imageSrc={item.imageSrc}
                  subtitleKey={item.subtitleKey}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}